import { X } from "lucide-react";
import { useState } from "react";
import { SITE } from "@/config/site";

function getStoreUrl() {
  const userAgent = navigator.userAgent || "";
  const isModernIPad = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (/Android/i.test(userAgent) && SITE.storeLinks.android) return SITE.storeLinks.android;
  if ((/(iPhone|iPad|iPod)/i.test(userAgent) || isModernIPad) && SITE.storeLinks.ios) return SITE.storeLinks.ios;
  return null;
}

function isDismissed() {
  try {
    return Number(window.localStorage.getItem(SITE.appPromotion.dismissStorageKey)) > Date.now();
  } catch {
    return false;
  }
}

export function AppPromotionBanner() {
  const [isVisible, setIsVisible] = useState(() => !isDismissed());
  const storeUrl = getStoreUrl();

  const dismiss = () => {
    try {
      window.localStorage.setItem(SITE.appPromotion.dismissStorageKey, String(Date.now() + SITE.appPromotion.dismissForDays * 86400000));
    } catch {
      // The banner still dismisses for this visit if storage is unavailable.
    }
    setIsVisible(false);
  };

  const handleCta = (event) => {
    if (storeUrl || window.location.pathname !== "/") return;
    event.preventDefault();
    const target = document.getElementById("download");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    target?.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
  };

  if (!isVisible) return null;
  return <aside className="app-promotion-banner" aria-label="Vmemoo app availability" data-testid="app-promotion-banner">
    <div className="app-promotion-inner">
      <button className="app-promotion-dismiss" type="button" onClick={dismiss} aria-label="Dismiss Vmemoo app availability banner" data-testid="app-promotion-dismiss"><X size={18} aria-hidden="true" /></button>
      <img className="app-promotion-icon" src={SITE.appPromotion.icon} alt="Vmemoo app icon" width="1536" height="1536" data-testid="app-promotion-icon" />
      <div className="app-promotion-copy"><strong>Social Network for Memories</strong><span>A Home for every memory.</span></div>
      <a className="app-promotion-cta" href={storeUrl || "/#download"} onClick={handleCta} aria-label="View Vmemoo app availability" data-testid="app-promotion-cta">View</a>
    </div>
  </aside>;
}